import { useMutation } from 'react-query'
import { croneJobsService } from 'src/services/crone-jobs.service'

export const useUpdateEsgTrends = () => {
  return useMutation(() => croneJobsService.updateEsgTrends(), {})
}
